/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Image, Typography } from 'tfc-components';

import feature_1 from 'assets/images/home/feature_1.png';
import feature_1_extend from 'assets/images/home/feature_1_extend.png';
import feature_2 from 'assets/images/home/feature_2.png';
import feature_2_extend from 'assets/images/home/feature_2_extend.png';
import feature_3 from 'assets/images/home/feature_3.png';
import Icon from 'components/atoms/Icon';
import Section from 'components/organisms/Section';

interface IFeature {
  image: string;
  title: string;
  description: string;
  services: string[];
  id: number;
  isExtend?: boolean;
  extend?: string;
}

interface FeatureItemProps {
  item: IFeature;
  index: number;
}

const FeatureItem: React.FC<FeatureItemProps> = ({ item, index }) => (
  <div
    className={`p-home_feature_itemContainer ${index % 2 !== 0 ? 'p-home_feature_itemContainer-reverse' : ''
      }`}
  >
    <div className={`p-home_feature_imageContainer${index % 2 !== 0 ? 'Right' : ''}`}>
      <Image
        extendClasses={`p-home_feature_itemImage ${index === 2 ? 'p-home_feature_itemImageLast' : ''
          }`}
        imgSrc={item.image}
        alt="Resolve Image"
        ratio={1}
      />
      {item.id === 1 && (
        <Image
          extendClasses="p-home_feature_extentImg"
          imgSrc={feature_1_extend}
          alt="Feature Image"
          ratio={1}
        />
      )}
      {item.id === 2 && (
        <Image
          extendClasses="p-home_feature_extentImgRight"
          imgSrc={item.extend!}
          alt="Feature Image 2"
          ratio={1}
        />
      )}
    </div>
    <div
      className={`p-home_feature_itemContent ${index % 2 !== 0 ? 'p-home_feature_itemContent-reverse' : ''
        }`}
    >
      <Typography.Heading
        type="h3"
        fontweight="600"
        extendClasses="f-28x33 p-home_feature_title"
      >
        {item.title}
      </Typography.Heading>
      <Typography.Text
        extendClasses="p-home_feature_description"
        fontweight="400"
      >
        {item.description}
      </Typography.Text>
      {item.services.map((service, indexSevice) => (
        <div className="p-home_feature_serviceWrap" key={indexSevice}>
          <Icon iconName="checkedOrange" size="20" />
          <Typography.Text extendClasses="p-home_feature_service">
            {service}
          </Typography.Text>
        </div>
      ))}
    </div>
  </div>
);

const data: IFeature[] = [
  {
    image: feature_1,
    title: 'Boost customer satisfaction while reducing support volume',
    description:
      'Say goodbye to long wait times, repetitive tickets, and overwhelmed support teams. Our AI Chatbot responds instantly, operates 24/7, and handles the repetitive stuff – so your team can focus on what matters.',
    services: [
      'Cut 70% of your support volume',
      'Instantly resolve common questions',
      'Happier customers. Lower costs.'
    ],
    id: 1,
  },
  {
    image: feature_2,
    title: 'Knowledge sources',
    description:
      'Boost your agent’s ability to answer questions by pointing it to your enterprise data across a variety of public and private knowledge sources, including Help Center articles, internal support content, PDFs, and URLs.',
    services: [
      'Instantly learns from',
      'Auto-syncs new data from your site',
      'Auto-syncs new data from your site'
    ],
    id: 2,
    isExtend: true,
    extend: feature_2_extend
  },
  {
    image: feature_3,
    title: 'Any channel. Any language.',
    description:
      'Whether your customers reach out via website, mobile app, Facebook, or Zalo – the chatbot’s ready to respond. It speaks 90+ languages and adapts to your workflow.',
    services: [
      'Seamless multi-platform support',
      'Responds in your customers’ language',
      'Global-ready. 24/7 coverage.'
    ],
    id: 3
  },
];

const Feature: React.FC = () => (
  <Section className="p-home_feature">
    <Section.Title sectionName="Overview" className="p-home_feature_titleSection">
      Transform business processes across
      <br />
      <span className="p-home_feature_titleIndent">your entire organization with</span>
      <br />
      <span className="p-home_feature_titleIndent">custom agents</span>
    </Section.Title>
    <div className="p-home_feature_content">
      <div className="p-home_feature_group">
        {data.slice(0, 1).map((item, index) => (
          <FeatureItem key={item.id} item={item} index={index} />
        ))}
      </div>

      <div className="p-home_feature_groupWithBg">
        {data.slice(1).map((item, index) => (
          <FeatureItem key={item.id} item={item} index={index + 1} />
        ))}
      </div>
    </div>
  </Section>
);

export default Feature;
